import { useStore } from "react-redux";

const ServiceContactInfo = (props) => {
  const { configStorage } = useStore().getState();
 
  return (
    <>
        {!configStorage.isKundenShop() ?
            <div className="mt-1">
                {configStorage.isDeuBa() ?
                <div className="deuba-berater-contact-info">
                    Bei Fragen oder Problemen wenden Sie sich an das Kompetenzzentrum Sorten und Edelmetalle. E-Mail: <a href="mailto:DB-SE@db.com">DB-SE@db.com</a>
                </div>              
                : (configStorage.isVerseNeo() ?
                    <div className="sparkasse-berater-contact-info">
                        Bei Fragen oder Problemen wenden Sie sich an das Vertriebsteam Sorten und Edelmetalle der BayernLB. Telefon: 0911 2359-470, <span style={{ whiteSpace: 'nowrap' }}>E-Mail: <a href="mailto:se-vertrieb@bayernlb.de">se-vertrieb@bayernlb.de</a></span>
                    </div>
                    :
                    <div className="berater-contact-info">
                        Bei Fragen oder Problemen wenden Sie sich an das Vertriebsteam Sorten und Edelmetalle der BayernLB. Telefon: 0911 2359-470, E-Mail: <a href="mailto:se-vertrieb@bayernlb.de">se-vertrieb@bayernlb.de</a>
                    </div>
                )
                }
            </div>
            : null
        }
    </>)
};

export default ServiceContactInfo;
